<div class="header-main">
    <div class="header-inner">
        <div class="sitebranding">
            <a href="/">
                <img src="/assets/images/logo-computershare-colour.svg" alt="Computershare Logo" />
            </a>
        </div>
    </div>
</div>
